export const WEBHOOK_SOURCES = [
  { value: 'name', label: 'First name' },
  { value: 'lastname', label: 'Last name' },
  { value: 'email', label: 'Email' },
  { value: 'phone', label: 'Phone' },
  { value: 'answer', label: 'Answer' },
  { value: '_id', label: 'Participant ID' },
  { value: 'websiteUrl', label: 'Website URL' },
  { value: 'constant', label: 'Custom value' },
  { value: 'null', label: 'null (literal)' },
] as const

export type WebhookSource = (typeof WEBHOOK_SOURCES)[number]['value']

export type WebhookField = { key: string; source: WebhookSource; value?: string }

export const WEBHOOK_PRESETS: Record<string, { label: string; fields: WebhookField[] }> = {
  three: {
    label: 'Three',
    fields: [
      { key: 'GA_ID', source: 'null' },
      { key: 'SESSION_ID', source: 'null' },
      { key: 'WEBSITE_URL', source: 'websiteUrl' },
      { key: 'CHANNEL', source: 'constant', value: 'BIOSPIL' },
      { key: 'Telefonnummer', source: 'phone' },
      { key: 'Email', source: 'email' },
      { key: 'Navn', source: 'name' },
      { key: 'shoppingBasket_content', source: 'answer' },
      { key: 'SignupPage', source: 'null' },
      { key: 'FormID', source: 'null' },
      { key: 'UniqueID', source: '_id' },
      { key: 'CONSENT_FIRST', source: 'constant', value: 'True' },
    ],
  },
  unicef: {
    label: 'Unicef',
    fields: [
      { key: 'fornavn', source: 'name' },
      { key: 'efternavn', source: 'lastname' },
      { key: 'mail', source: 'email' },
      { key: 'telefonnr', source: 'phone' },
      { key: 'source', source: 'constant', value: 'cinemataztic' },
      { key: 'campaignId', source: 'constant', value: '' },
    ],
  },
}
